<div class="impedance-container" *ngIf="isImpedanceData">
  <div class="lighter">
    <p>{{'GENIUS_SETTINGS.CHANNEL_TEXT' | translate}} <span class="impedance-value">{{impedanceFirstChannelKOhms}}</span> kΩ</p>
    <div class="circle" [ngStyle]="getFirstLighterColor()">
        <div class="negative-impedance" *ngIf="impedanceFirstChannelKOhms < 0">
          <p>{{'GENIUS_SETTINGS.NEGATIVE_IMPEDANCE' | translate}}</p>
        </div>
    </div>
  </div>
<!--  <button (click)="sim()">los</button>-->
<!--  <div class="lighter">-->
<!--    <p>Ch2: {{impedanceSecondChannelKOhms}} kOhms</p>-->
<!--    <div class="circle" [ngStyle]="getSecondLighterColor()"></div>-->
<!--  </div>-->
</div>
<div class="simulator-container" *ngIf="currentUser?.role !== 'normal'">
  <button mat-raised-button
          class="settings-button"
          id="simulator-button"
          tourAnchor="simulator-tour"
          (click)="toggleSimulatorMode()"
          [ngClass]="isSimulatorMode? 'simulator-on' : 'toggle-button'"
          [disabled]="device"
          *ngIf="!device">
    {{isSimulatorMode ? ('SIMULATOR_MODE.SIMULATOR_OFF' | translate) : ('SIMULATOR_MODE.SIMULATOR_ON' | translate)}}
  </button>
</div>
<section class="setting-section" *ngIf="!isSimulatorMode">
  <div class="how-to-use-container">
    <button (click)="openYoutubeLink()" class="youtube-link" [ngbTooltip]="bluetoothHint()">
      <img src="./assets/images/youtube.png" alt="youtube">
    </button>
    <button mat-raised-button (click)="openInfoDialog($event)" class="info-button settings-button" tourAnchor="info-tour" [ngbTooltip]="bluetoothHint()">
      <span class="material-icons">
        info
      </span>
    </button>
  </div>

  <div class="settings-container">
    <div class="timer-container" *ngIf="showTimer">
      <p>{{timerView}}</p>
    </div>
    <button [ngbTooltip]="bluetoothHint()" [ngClass]="{'disabled-button' : subscriptionsError} " mat-raised-button tourAnchor="connect-device-tour" [disabled]="subscriptionsError" (click)="toggleConnectDevice()"
            class="toggle-button settings-button">{{isSensorConnected ? ('GENIUS_SETTINGS.DISCONNECT_TEXT' | translate) : ('GENIUS_SETTINGS.CONNECT_TEXT' | translate)}}</button>
    <mat-spinner [diameter]="25" class="connecting-spinner" *ngIf="isLoading"></mat-spinner>
    <div class="device-info" *ngIf="device || isSensorConnected && percentage">
      <img class="energy-icon" src="../../../assets/images/energy-icon.png">
      <div class="percentage-container">
        <p class="percentage-number">{{percentage}}%</p>
        <div class="percentage-line" [ngStyle]="lineWidth()"></div>
      </div>
    </div>
    <div class="status-dot">
<!--      <button (click)="dropPackets()">DROP</button>-->
       <span class="material-symbols-outlined bluetooth-icon"
             *ngIf="device"
             [ngClass]="{'status-dot-errors' : isSensorErrors(), 'status-dot-connected' : !isSensorErrors()}"
             [ngbTooltip]="sensorStatsTpl"
             triggers="hover click"
             placement="left-top"
             container="body"
             tooltipClass="sensor-stats-tooltip">
            bluetooth
          </span>
    </div>

    <ng-template #sensorStatsTpl>
      <div class="sensor-stats">
        <div class="device-stats">
          <div class="stat-row">
            <span class="stat-label">{{'SENSOR_STATS.TOTAL_PACKETS' | translate}}</span>
            <span class="stat-value">{{getSensorStats().totalPackets}}</span>
          </div>
          <div class="stat-row">
            <span class="stat-label">{{'SENSOR_STATS.PACKETS_DROPPED' | translate}}</span>
            <span class="stat-value">{{getSensorStats().packetsDropped}}</span>
          </div>
          <div class="stat-row">
            <span class="stat-label">{{'SENSOR_STATS.SYNC_ERROR' | translate}}</span>
            <span class="stat-value">{{getSensorStats().syncError}}</span>
          </div>
          <div class="stat-row">
            <span class="stat-label">{{'SENSOR_STATS.TOTAL_ERROR' | translate}}</span>
            <span class="stat-value">{{getSensorStats().totalErrorCount}}</span>
          </div>
        </div>
        <ng-container *ngIf="currentUser && currentUser.devices">
          <div class="device-name" *ngFor="let device of currentUser.devices;let isLast = last;">
            <span class="device-name-heading">{{'GENIUS_SETTINGS.PERSONAL_DEVICE' | translate}}</span>
            <span> {{device}}<span *ngIf="!isLast">,</span></span>
          </div>
        </ng-container>
      </div>
    </ng-template>
  </div>
</section>
<div class="electrode-position-menu" *ngIf="showElectrodePositionMenu">
  <div class="close" (click)="showElectrodePositionMenu = false">
    <mat-icon>close</mat-icon>
  </div>
  <kt-info-dialog></kt-info-dialog>
</div>
